import { render, staticRenderFns } from "./transferCategory.vue?vue&type=template&id=e1404af2&scoped=true&"
import script from "./transferCategory.vue?vue&type=script&lang=js&"
export * from "./transferCategory.vue?vue&type=script&lang=js&"
import style0 from "./transferCategory.vue?vue&type=style&index=0&id=e1404af2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1404af2",
  null
  
)

export default component.exports